<template>
  <div v-show="item.hide">
    <!-- 菜单 -->
    <div
      v-if="item.leaf"
      class="menu-c"
      :style="{marginLeft:14+level*14+'px',paddingLeft:38+'px'}"
      @click="handleClick(item)"
      :class="{'sel':(item.modelname)==(activeMenu?activeMenu.fullPath:''),'with-sub':item.sub}"
    >
      <!-- 名字 -->
      <span class="childMenu">{{item.name}}</span>
      <img src="../../assets/img/broadsideIcon/position.png" alt class="position" />
    </div>
    <!-- 文件夹 -->
    <div
      v-else
      class="menu-p"
      @click.stop="handleClick(item)"
      :style="{marginLeft:10+level*10+'px'}"
    >
      <!-- 图标 -->
      <img v-show="!navHidden" :src="itemImg" alt class="picon_icon" />
      <el-popover
        class="menu"
        v-if="navHidden"
        placement="left-start"
        width="100"
        :disabled="!item.children.length>0"
        :value="item.expand&&item.children.length>0"
        trigger="click"
      >
        <div class="collapse-menu">
          <p class="menu-p">{{item.name}}</p>
          <li
            :class="{'sel':(child.modelname)==(activeMenu?activeMenu.fullPath:'')}"
            class="menu-item"
            v-for="child in item.children"
            :key="child.id"
            @click="handleClick(child)"
          >{{child.name}}</li>
        </div>
        <img slot="reference" :src="itemImg" class="picon_icon" />
      </el-popover>
      <!-- 名字 -->
      <span
        @click.stop="handleClick(item)"
        :class="{'sel':(item.modelname)==(activeMenu?activeMenu.fullPath:'')}"
        class="menu-title"
        style="padding-left: 13px"
      >{{getMenuTitle(item.name)}}</span>

      <!-- 文件夹图标 -->
      <i
        class="right"
        v-if="item.children.length>0&&!navHidden"
        :class="item.expand?'el-icon-arrow-down':'el-icon-arrow-right'"
      ></i>
    </div>
    <!-- 子菜单 -->
    <div
      v-if="!item.leaf&&!navHidden"
      ref="c-panel"
      class="menu-c-panel"
      :class="item.expand?'open':'close'"
    >
      <menu-item
        v-for="child in item.children"
        :key="child.id"
        :item="child"
        :level="level+1"
        :activeMenu="activeMenu"
      >
      </menu-item>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bus from "../bus";
import { getLoginType } from "@/libs/until";

export default {
  name: "menuItem",
  props: ["item", "level", "activeMenu", "indexMenun", "allLength"],
  data: function() {
    return {
      positionShow: false,
      firstchange: true,
      checkIndexLast: "",
      icon: "",
      logintype:getLoginType()
    };
  },
  computed: {
    ...mapState({
      navHidden: state => state.menu.navHidden
    }),
    itemImg() {
      let img = "";
      try {
        img = require("../../assets/img/broadsideIcon/" +
          this.item.icon +
          ".png");
      } catch (err) {
        img = "";
      }
      return img;
    }
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        if (this.$route.meta.index != 0 && !this.$route.meta.index)
          return false;
        this.activeMenu.fullPath = this.$route.meta.modelname;
        let icon = this.item.icon ? this.item.icon : this.icon;
        if (!this.item.leaf && this.$route.meta.index == this.indexMenun) {
          this.item.expand = true;
          if (icon) {
            if (icon.indexOf("_check") == -1) {
              this.item.icon = icon + "_check";
            }
          }
          return true;
        } else {
          this.item.expand = false;
          if (icon) {
            if (icon.indexOf("_check") != -1) {
              this.item.icon = icon.substr(0, icon.length - 6);
            }
          }
          return true;
        }
      }
    }
  },
  mounted() {
    bus.$on("userD", val => {
      var icon = this.item.icon;
      if (this.indexMenun == val) {
        this.item.expand = !this.item.expand;
        //当前点击的父级菜单
        if (this.item.expand) {
          if (!this.item.leaf) {
            if (icon) {
              if (icon.indexOf("_check") == -1) {
                this.item.icon = this.item.icon + "_check";
              }
            }
          }
        } else {
          if (!this.item.leaf || this.item.children.length > 0) {
            if (icon) {
              if (icon.indexOf("_check") != -1) {
                this.item.icon = icon.substr(0, icon.length - 6);
              }
            }
          }
        }
      } else {
        this.item.expand = false;
        //没被点击的父菜单
        if (!this.item.expand) {
          if (!this.item.leaf) {
            if (icon) {
              if (icon.indexOf("_check") != -1) {
                this.item.icon = icon.substr(0, icon.length - 6);
              }
            }
          }
        }
      }
    });
    bus.$on("toggles", val => {
      var icon = this.item.icon;
      //没有子菜单
      if (this.indexMenun == val) {
        this.item.expand = true;
        if (icon) {
          if (icon.indexOf("_check") == -1) {
            this.item.icon = icon + "_check";
          }
        }
      } else {
        this.item.expand = false;
        if (icon) {
          if (icon.indexOf("_check") != -1) {
            this.item.icon = icon.substr(0, icon.length - 6);
          }
        }
      }
    });
  },

  methods: {
    //判断菜单名字
    getMenuTitle(name){
      if(this.logintype=='SHOP'||this.logintype=='DEALER'){
        return name=name==='违规处理'?'违规举报':name
      }else{
        return name
      }
    },
    // 打开菜单
    handleClick(node) {
      if (node.leaf || !node.children.length > 0) {
        this.icon = node.icon;
        this.$router.push({
          path: node.page,
          params: {
            resource: node.resource
          }
        });
        this.activeMenu.fullPath = node.modelname;
        if (node.children) {
          if (node.children.length == 0) {
            bus.$emit("toggles", this.indexMenun);
          }
        }
      } else {
        bus.$emit("userD", this.indexMenun);
        return false;
      }
    },
  }
};
</script>


<style lang="scss">
$lightColor: #cfa972;
#part-side-bar {
  // 菜单/文件夹共有样式
  &::-webkit-scrollbar {
    display: none;
  }
  .menu-p,
  .menu-c {
    cursor: pointer;
    font-size: 12px;
    color: #fff;
    line-height: 20px;
    height: 18px;
    padding: 13px 14px;
    white-space: nowrap;
    overflow: hidden;
    //   text-overflow: ellipsis;
    opacity: 1;
    transition: background 0.2s, height 0.2s, opacity 0.2s, padding 0.2s;
    .position {
      position: absolute;
      width: 11px;
      height: 6px;
      left: 2px;
      top: 21px;
      display: none;
    }
    &:hover{
			 color: $lightColor;
			.position {
				display: block;
			}
			&::before {
				display: none;
			}
		}
    &.with-sub {
      padding: 8px 14px;
      height: 56px;
    }
  }
  // 文件夹
  .menu-p {
    .picon {
      padding: 0 4px 0 0;
    }
    .picon_icon {
      padding: 0 4px 0 0;
      width: 22px;
      height: 21px;
      vertical-align: middle;
    }
    .icon_container {
      font-size: 20px;
    }
    .menu-title {
      font-size: 14px;
      &.sel {
        color: $lightColor;
      }
    }
    .right {
      vertical-align: middle;
      font-size: 14px;
      color: #bbbec4;
      float: right;
      padding: 5px 0 0 0;
      transition: transform 0.2s;
      &.open {
        transform: rotate(0);
      }
      &.close {
        transform: rotate(90deg);
      }
    }
  }
  // 菜单
  .menu-c {
    &.sel {
      color: $lightColor;
      background: url("../../assets/img/broadsideIcon/position.png") no-repeat;
      background-position: 2px 22px;
      &::after {
        background: $lightColor !important;
      }
      &::before {
        display: none;
      }
    }
  }
  // 子菜单
  .menu-c-panel {
    background: #151e33;
    position: relative;
    .menu-p {
      display: flex;
      justify-content: flex-start;
    }
    &.close {
      .menu-p,
      .menu-c {
        height: 0;
        opacity: 0;
        padding: 0 14px;
      }
    }
    .menu-c {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: 3px;
        width: 7px;
        height: 7px;
        background: #ddd;
        border-radius: 7px;
      }
      &::after {
        content: "";
        position: absolute;
        top: 0px;
        left: 6px;
        width: 1px;
        height: 45px;
        background: #dddddd9c;
      }
    }
  }
}

// 收缩后的菜单
.collapse-menu {
  .menu-p {
    font-weight: 600;
    margin: 10px 0;
  }
  .menu-item {
    display: block;
    line-height: 28px;
    cursor: pointer;
    &.sel {
      color: #cfa972;
    }
    &:hover {
      color: #cfa972;
    }
  }
}
</style>
